export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

export function setParamProcess(state, process) {
    state.params.process = process;
}



// WEBPACK FOOTER //
// ./src/modules/special-processes/mutations.js